module.exports = __webpack_public_path__ + "img/block_2_green_pin.517d870d.png";